export default __webpack_public_path__ + "static/media/home1.6c4dc750.jpg";